<script setup>
import { computed, ref, watch } from 'vue'
import { usePageGuide } from '@/composables/usePageGuide'
import { isPanelHelpRoute } from '@/utils/panelHelp'

const props = defineProps({ title: { type: String, default: 'این صفحه' } })
const route = useRoute()
const guide = usePageGuide()
const opened = ref(false)
const sections = computed(() => guide?.sections.value || [])
const available = computed(() => isPanelHelpRoute(route.path) && sections.value.length > 0)
watch(() => route.fullPath, () => { opened.value = false })
</script>

<template>
  <span v-if="available" class="page-guide">
    <button type="button" class="page-guide__trigger" :aria-label="`راهنمای ${props.title}`" aria-haspopup="dialog" :aria-expanded="opened" @click="opened = true">
      <VIcon icon="tabler-info-circle" size="21" />
    </button>
    <VDialog v-model="opened" max-width="640" scrollable>
      <VCard class="page-guide__dialog" dir="rtl">
        <VCardTitle class="page-guide__heading">
          <span>راهنمای {{ props.title }}</span>
          <VBtn icon="tabler-x" variant="text" size="small" aria-label="بستن راهنما" @click="opened = false" />
        </VCardTitle>
        <VCardText class="page-guide__body">
          <ol class="page-guide__sections">
            <li v-for="section in sections" :key="`${section.title}:${section.text}`">
              <strong v-if="section.title">{{ section.title }}</strong>
              <p>{{ section.text }}</p>
            </li>
          </ol>
        </VCardText>
        <VCardActions><VSpacer /><VBtn color="primary" variant="tonal" @click="opened = false">متوجه شدم</VBtn></VCardActions>
      </VCard>
    </VDialog>
  </span>
</template>

<style scoped>
.page-guide { display:inline-flex; vertical-align:middle; margin-inline-start:8px; }
.page-guide__trigger { display:inline-flex; align-items:center; justify-content:center; width:40px; height:40px; flex-shrink:0; padding:0; border:0; border-radius:50%; background:transparent; color:rgb(var(--v-theme-primary)); cursor:pointer; }
.page-guide__trigger:hover,.page-guide__trigger:focus-visible { background:rgba(var(--v-theme-primary),.09); outline:2px solid rgba(var(--v-theme-primary),.25); }
.page-guide__dialog { border-radius:20px!important; }
.page-guide__heading { display:flex; align-items:center; justify-content:space-between; gap:12px; padding:16px 20px; white-space:normal; font-size:17px; border-bottom:1px solid rgba(var(--v-theme-primary),.1); }
.page-guide__body { padding:20px!important; }
.page-guide__sections { display:grid; gap:16px; margin:0; padding-inline-start:22px; font-size:13px; line-height:2; }
.page-guide__sections li::marker { color:rgb(var(--v-theme-primary)); font-weight:700; }
.page-guide__sections strong { display:block; margin-bottom:4px; }
.page-guide__sections p { margin:0; white-space:normal; overflow-wrap:anywhere; }
@media(max-width:599px) { .page-guide__heading { padding:12px 16px; font-size:15px; } .page-guide__body { padding:16px!important; } }
</style>
